import React from 'react';
import { Edit, SimpleForm } from 'react-admin';

import { CustomToolbar, Grid } from '../../components'
import UserChannelFields from './UserChannelFields'

export const UserChannelEdit = props => (
  <Edit {...props}>
    <SimpleForm toolbar={<CustomToolbar />}>
      <Grid container spacing={8}>
        <UserChannelFields />
      </Grid>
    </SimpleForm>
  </Edit>
);

export default UserChannelEdit
